import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import CarNavigationLinkItem from '../../containers/car-navigation-link-item';

const CarNavigationLinkItemBlock = props => <CarNavigationLinkItem {...props} />;
CarNavigationLinkItemBlock.displayName = 'CarNavigationLinkItem';

export default withDynamicComponents({
  componentWhitelist: [
    
  ],
  mapInputToOutput: [
    // ['passengerCarFilters', 'passengerCarFilters'],
    // ['models', 'models'],
  ],
})(CarNavigationLinkItemBlock);



// WEBPACK FOOTER //
// ./src/blocks/car-navigation-link-item/index.jsx